// @flow

import React from 'react';
import { Route, IndexRoute } from 'react-router';
import { Tracking } from 'web-core/src/tracking';
import TranslationProvider from 'client/components/translationProvider';
import App from './app';
import LifePage from './lifePage';
import LifeQuotePage from './lifeQuotePage'; // * Variant of life page, remove after test complete

function bindPageViewTracking() {
  return () => {
    Tracking.trackPageView();
    Tracking.track('Landing Page Viewed', { Page: 'Life' });
  };
}

export default (
  <Route path="/" component={App}>
    <Route component={TranslationProvider} keys={['app', 'common', 'life']}>
      <IndexRoute component={LifePage} onEnter={bindPageViewTracking()} />
      <Route path="quote" component={LifeQuotePage} onEnter={bindPageViewTracking()} />
    </Route>
  </Route>
);
